function trackPageView(publish_date, updated_date) {
    const periods = [
        { days: 7, label: 'recent' },
        { days: 30, label: 'month' },
        { days: 90, label: 'quarter' }
    ];

    const today = new Date();
    const publishDate = new Date(publish_date);
    const updatedDate = new Date(updated_date);

    // Calculate differences in days
    const msPerDay = 1000 * 60 * 60 * 24;
    const daysSincePublish = Math.floor((today - publishDate) / msPerDay);
    const daysSinceUpdate = Math.floor((today - updatedDate) / msPerDay);


    periods.forEach(period => {
        if(daysSincePublish < period.days) {
            dataLayer.push({
                'event': `mag_article_${period.label}_published`
            });
        }

        if(daysSinceUpdate < period.days) {
            dataLayer.push({
                'event': `mag_article_${period.label}_updated`
            });
        }
    });
}
